import { type FC } from "react";

import { Card, CardRowSimple, type GridCard, TimeAgo } from "widgets";

import { type Database, type Organism } from "../../../graphql.js";

export interface IDatabaseCardProps extends GridCard {
  database: Database;
  genome: Organism;
}

const DatabaseCard: FC<IDatabaseCardProps> = (props) => {
  const database: Database = props.database;

  if (!database) {
    return null;
  }

  return (
    <Card title={`Database Info: ${database.mnemonic}`} subtitle={database.name}>
      <CardRowSimple label={"Version"} value={database.version} />
      <CardRowSimple label={"Owner"} value={database.owner} />
      {database.created && <CardRowSimple label={"Created"} value={<TimeAgo dateTimeISO={database.created} />} />}
      {database.modified && <CardRowSimple label={"Modified"} value={<TimeAgo dateTimeISO={database.modified} />} />}
    </Card>
  );
};

export { DatabaseCard };
